import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/addBestsellersOnGridPages/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAddBestsellersOnGridPagesSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAddBestsellersOnGridPagesSelector };
